import React, { useEffect, useState } from "react";

import { Container } from "react-bootstrap";

import { useDispatch, useSelector } from "react-redux";
import {
  CLEAR_ERROR,
  IMMIGRATION_CREATE_REQUESTED,
  IMMIGRATION_GET_ALL_REQUESTED,
  IMMIGRATION_UPDATE_REQUESTED,
} from "../../../redux/actions";
import ReactGA from "react-ga";
import { useFormik } from "formik";
import * as Yup from "yup";
import ImmigrationForm from "../../../components/ImmigrationForm/ImmigrationForm";
import SnackbarContent from "../../../components/Snackbar/SnackbarContent";
import CustomLinearProgress from "../../../components/CustomLinearProgress/CustomLinearProgress";

export default function ImmigrationContainer({
  open,
  setOpen,
  editData = {},
  isEdit,
  ...other
}) {
  const initialValues = {
    id: "",
    familyName: "",
    givenName: "",
    sex: "",
    dob: "",
    passportNumber: "",
    countryOfPassport: "",
    nationalityOfPassportHolder: "",
    dateOfIssue: "",
    dateOfExpiry: "",
    placeOfIssue: "",
    birthCity: "",
    birthState: "",
    birthCountry: "",
    email: "",
    phone: "",
  };

  const mySchema = () => {
    return Yup.object({
      id: Yup.number(),
      familyName: Yup.string(),
      givenName: Yup.string(),
      sex: Yup.string(),
      dob: Yup.string(),
      passportNumber: Yup.string(),
      countryOfPassport: Yup.string(),
      nationalityOfPassportHolder: Yup.string(),
      dateOfIssue: Yup.string(),
      dateOfExpiry: Yup.string(),
      placeOfIssue: Yup.string(),
      birthCity: Yup.string(),
      birthState: Yup.string(),
      birthCountry: Yup.string(),
      email: Yup.string(),
      phone: Yup.string(),
    });
  };

  const onSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
      return;
    }

    if (isEdit) {
      const payload = values;
      dispatch({
        type: IMMIGRATION_UPDATE_REQUESTED,
        payload,
        id: values.id,
      });
      ReactGA.event({
        category: "Immigration",
        action: "Update Immigration profile",
      });
      console.log(values);
    } else {
      const payload = values;
      dispatch({
        type: IMMIGRATION_CREATE_REQUESTED,
        payload,
      });
      ReactGA.event({
        category: "Immigration",
        action: "Add Immigration profile",
      });
    }
  };

  const { values, handleChange, setFieldValue, resetForm } = useFormik({
    initialValues,
    validationSchema: mySchema(),
    onSubmit,
  });
  // Formic Config Done ----------------

  const dispatch = useDispatch();

  const [validated, setValidated] = useState(false);

  const createEditSuccess = useSelector(
    (state) => state.immigration.immigrationCreateEditSuccess
  );
  const createEditProgress = useSelector(
    (state) => state.immigration.immigrationCreateEditFetching
  );
  const createEditFailure = useSelector(
    (state) => state.immigration.immigrationCreateEditFailure
  );
  const errorMsg = useSelector((state) => state.immigration.errorMsg);

  useEffect(() => {
    dispatch({ type: CLEAR_ERROR });
  }, []);

  useEffect(() => {
    if (Object.keys(editData).length > 0) {
      for (let field of Object.keys(initialValues)) {
        if (editData[field] !== null) {
          setFieldValue(field, editData[field], false);
        }
      }
    }
  }, [editData]);

  useEffect(() => {
    if (createEditSuccess === true) {
      // setTimeout(() => {
      //   setOpen(false);
      // }, 700);
      dispatch({ type: IMMIGRATION_GET_ALL_REQUESTED });
      // setTimeout(() => {
      //   resetForm(initialValues);
      //   dispatch({ type: CLEAR_ERROR });
      // }, 701);
      setValidated(false);
    }
    if (open === false) {
      resetForm(initialValues);
      dispatch({ type: CLEAR_ERROR });
      setValidated(false);
    }
  }, [createEditSuccess, open]);

  return (
    <Container fluid {...other}>
      <ImmigrationForm
        values={values}
        isEdit={isEdit}
        validated={validated}
        handleSubmit={onSubmit}
        handleSelect={handleChange}
      />
      {createEditFailure && (
        <SnackbarContent
          message={errorMsg || "Something went wrong."}
          color="warning"
        />
      )}
      {createEditProgress && <CustomLinearProgress color="primary" />}
      {createEditSuccess && (
        <SnackbarContent message="Success" color="success" />
      )}
    </Container>
  );
}
